import { useMemo } from 'react';
import { AIInsights, MetricsType } from '@features/ai-insights';
import { RslReport } from '../api/schema';

type AIInsightsHook = {
  rslAiInsights: AIInsights | null;
  visitInsights: AIInsights | null;
};

export const useRslAIInsights = (
  report: Pick<RslReport, 'aiInsights' | 'visitAIInsights'> | null,
  metricsType: MetricsType,
  dimensionName: string | null = null
): AIInsightsHook => {
  return useMemo(() => {
    const rslInsights = (report?.aiInsights ?? []).find(
      i => i.metricsType === metricsType && i.dimensionName === dimensionName
    );
    const visitInsights = (report?.visitAIInsights ?? []).find(
      i => i.metricsType === metricsType && i.dimensionName === dimensionName
    );

    return {
      rslAiInsights: rslInsights ?? null,
      visitInsights: visitInsights ?? null,
    };
  }, [dimensionName, metricsType, report?.aiInsights, report?.visitAIInsights]);
};
